import { useState } from "react";
import { useCreateTransactionVerifyOtp } from "../../../features/transaction";
import { useParams } from "react-router-dom";

const VerifyOTP = () => {
  const { transactionId } = useParams<{ transactionId: string }>();

  const [formData, setFormData] = useState({
    transactionId: transactionId ?? "",
    otp: "",
  });
  const { verifyOtp: Create } = useCreateTransactionVerifyOtp();
  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log(formData);
    if (transactionId) {
      Create(formData);
    }
  };

  return (
    <div className="p-6">
      <h1 className="text-base font-bold mb-4 text-center">Verify OTP</h1>
      <form onSubmit={handleSubmit}>
        <div className="mb-4">
          <label
            htmlFor="discount"
            className="block text-sm font-medium text-gray-700"
          >
            OTP
          </label>
          <input
            type="number"
            id="otp"
            name="otp"
            value={formData.otp}
            onChange={handleChange}
            className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
          />
        </div>
        <button
          type="submit"
          className="w-full mt-10 py-2 px-4 bg-indigo-600 text-white font-medium rounded-md hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500"
        >
          Submit
        </button>
      </form>
    </div>
  );
};

export default VerifyOTP;
